import { render } from "./Scoreboard.vue?vue&type=template&id=64fabc0e&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"

import "./Scoreboard.vue?vue&type=style&index=0&id=64fabc0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fabc0e"]])

export default __exports__